
namespace SP {
    var n = 0;
    export function duplicate(original: HTMLElement): HTMLElement {
        var clone = original.cloneNode(true) as HTMLElement; // "deep" clone
        clone.id += ++n; // there can only be one element with an ID
        return clone;
    }
}